<template>

            <!--<v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="time"                
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
            >
                <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="time"
                    :label="text"
                    prepend-icon="fa-clock"
                    readonly
                    v-on="on"
                ></v-text-field>
                </template>
                <v-time-picker
                v-if="menu"
                v-model="time"
                format="24hr"
                @click:minute="$refs.menu.save(time)"
                ></v-time-picker>
            </v-menu>-->
  <v-container fluid>
    <v-row>
      <v-col cols="12">

                <div style="display:flex; flex: 1 1 auto; -webkit-flex:1; -ms-flex: 1 1 auto; position:relative" id="container">
                  <label for="timepicker" class="v-label v-label--active theme--light" style="left:0px; right: auto; position: absolute;">{{text}}</label>
                  <ejs-timepicker id="timepicker" placeholder="Wybierz godzine..." v-model="time" :format="customFormat" :min="minDate" :step="timeScaleValue"  :enableMask="mask" :maskPlaceholder='maskPlaceholderValue' :openOnFocus="openOnFocus" :showClearButton="showClearButton"></ejs-timepicker>
                </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import Vue from "vue";
import { TimePickerPlugin, MaskedDateTime  } from "@syncfusion/ej2-vue-calendars";
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {mapState} from "vuex";
Vue.use(TimePickerPlugin);
dayjs.extend(customParseFormat);
export default {
    name: 'TimePicker',
    data () {
      return {
        time: null,
        menu: false,
        mask: false,
        openOnFocus: true,
        showClearButton: true,
        interval:30,
        customFormat: "HH:mm",
        maskPlaceholderValue: { hour: 'godziny', minute: 'minuty', second: 'sekundy' }
      }
    },
    props: ["value","text", "allowallhours", "minTime","timeScale"],
    watch: {
      time(val) {
            if(val) {
                let emitValue = dayjs(val).format('HH:mm:ss')
                this.$emit('input',emitValue)
              //document.body.style.background = val;
            }
        },
        value(val) {
          if(val) {            
            let nval = dayjs(this.value, 'HH:mm').toDate()
            this.time = nval
          }
        }
    },
  mounted() {
    if(this.value) {
      let nval = dayjs(this.value, 'HH:mm').toDate()
      this.time = nval
    }
    const els = document.querySelectorAll('#container .e-icons');
    els.forEach(item => {
      item.style.fontSize = '24px'
    })
    const clearIcons = document.querySelectorAll('#container .e-clear-icon');
    clearIcons.forEach(item => {
      item.style.fontSize = '24px'
    })

  },
  computed: {
      ...mapState('companySettingsModule',['settings']),
    minDate() {
      if(this.minTime) {        
          return new dayjs(this.minTime, 'HH:mm').toDate();
        }
        if(!this.allowallhours)
          return new dayjs(this.settings.godzina_otwarcia_start).toDate()
        else
          return null
    },
    timeScaleValue() {
      if(this.timeScale > 0) {
        return this.timeScale
      }
      return 30
    }
  },
  provide: {
      timepicker: [MaskedDateTime]
  }

}
</script>

<style scoped>
.e-icons {
  font-size: 24px !important;
}
#timepicker {
  font-size: 16px;
  font-family: Roboto, sans-serif;
  font-stretch: 100%;
  padding-top: 10px;
}
#container label {
  -webkit-transform-origin: top left;
  transform-origin: top left;
  transform: translateY(-5px) scale(.75);
  pointer-events: auto;
}

</style>
